import Vue from 'vue';
import VueRouter from 'vue-router';
import config from "@/services/config";

Vue.use(VueRouter);
const router = new VueRouter({
  routes: [
    {
      path: '/',
      redirect: { 
        name: 'login'
      },
    },
    {
      path: '/login',
      name: 'login',
      component: (): Promise<any> => import(/* webpackChunkName: "configuration" */ './views/Login.vue'),
      props: true
    },    
    {
      path: '/censimentoProdotti',
      name: 'censimento-prodotti',
      component: (): Promise<any> => import(/* webpackChunkName: "configuration" */ './views/CensimentoProdotti.vue'),
      props: true
    },
    {
      path: '/database',
      name: 'database',
      component: (): Promise<any> => import(/* webpackChunkName: "configuration" */ './views/Database.vue'),
      props: true
    },
    {
      path: '/home',
      name: 'home',
      component: (): Promise<any> => import(/* webpackChunkName: "configuration" */ './views/Home.vue'),
      props: true
    },
    {
      path: '/cambioPassword',
      name: 'cambio-password',
      component: (): Promise<any> => import(/* webpackChunkName: "configuration" */ './views/CambioPassword.vue'),
      props: true
    },
    {
      path: '/recuperoPassword',
      name: 'recupero-password',
      component: (): Promise<any> => import(/* webpackChunkName: "configuration" */ './views/RecuperoPassword.vue'),
      props: true
    },
    /* PIATTAFORMA PRODOTTI */
    {
      path: '/homeProdotti',
      name: 'home-prodotti',
      component: (): Promise<any> => import(/* webpackChunkName: "configuration" */ './views/' + config.codCliente + '/piattaforma-prodotti/Home.vue')
        .catch((component : any) => {
          return import(/* webpackChunkName: "configuration" */ './views/piattaforma-prodotti/Home.vue');
        }),
      props: true
    },
    {
      path: '/vitaInvestimento',
      name: 'vita-investimento',
      component: (): Promise<any> => import(/* webpackChunkName: "configuration" */ './views/' + config.codCliente + '/piattaforma-prodotti/censimento/VitaInvestimento.vue')
        .catch((component : any) => {
          return import(/* webpackChunkName: "configuration" */ './views/piattaforma-prodotti/censimento/VitaInvestimento.vue');
        }),
      props: true
    },
    {
      path: '/vitaProtezione',
      name: 'vita-protezione',
      component: (): Promise<any> => import(/* webpackChunkName: "configuration" */ './views/' + config.codCliente + '/piattaforma-prodotti/censimento/VitaProtezione.vue')
        .catch((component : any) => {
          return import(/* webpackChunkName: "configuration" */ './views/piattaforma-prodotti/censimento/VitaProtezione.vue');
        }),
      props: true
    },
    {
      path: '/danniAuto',
      name: 'danni-auto',
      component: (): Promise<any> => import(/* webpackChunkName: "configuration" */ './views/' + config.codCliente + '/piattaforma-prodotti/censimento/DanniAuto.vue')
        .catch((component : any) => {
          return import(/* webpackChunkName: "configuration" */ './views/piattaforma-prodotti/censimento/DanniAuto.vue');
        }),
      props: true
    },
    {
      path: '/danniNonAuto',
      name: 'danni-non-auto',
      component: (): Promise<any> => import(/* webpackChunkName: "configuration" */ './views/' + config.codCliente + '/piattaforma-prodotti/censimento/DanniNonAuto.vue')
        .catch((component : any) => {
          return import(/* webpackChunkName: "configuration" */ './views/piattaforma-prodotti/censimento/DanniNonAuto.vue');
        }),
      props: true
    },
    {
      path: '/cpiPPI',
      name: 'cpi-ppi',
      component: (): Promise<any> => import(/* webpackChunkName: "configuration" */ './views/' + config.codCliente + '/piattaforma-prodotti/censimento/CPI-PPI.vue')
        .catch((component : any) => {
          return import(/* webpackChunkName: "configuration" */ './views/piattaforma-prodotti/censimento/CPI-PPI.vue');
        }),
      props: true
    },
    {
      path: '/protezioneInvestimento',
      name: 'protezione-investimento',
      component: (): Promise<any> => import(/* webpackChunkName: "configuration" */ './views/' + config.codCliente + '/piattaforma-prodotti/censimento/ProtezioneInvestimento.vue'),
      props: true
    },
    {
      path: '/protezionePersona',
      name: 'protezione-persona',
      component: (): Promise<any> => import(/* webpackChunkName: "configuration" */ './views/' + config.codCliente + '/piattaforma-prodotti/censimento/ProtezionePersona.vue'),
      props: true
    },
    {
      path: '/protezioneImprese',
      name: 'protezione-imprese',
      component: (): Promise<any> => import(/* webpackChunkName: "configuration" */ './views/' + config.codCliente + '/piattaforma-prodotti/censimento/ProtezioneImprese.vue'),
      props: true
    },
    {
      path: '/protezionePatrimonio',
      name: 'protezione-patrimonio',
      component: (): Promise<any> => import(/* webpackChunkName: "configuration" */ './views/' + config.codCliente + '/piattaforma-prodotti/censimento/ProtezionePatrimonio.vue'),
      props: true
    },
    {
      path: '/protezioneCredito',
      name: 'protezione-credito',
      component: (): Promise<any> => import(/* webpackChunkName: "configuration" */ './views/' + config.codCliente + '/piattaforma-prodotti/censimento/ProtezioneCredito.vue'),
      props: true
    },
    {
      path: '/databaseVitaInvestimento',
      name: 'database-vita-investimento',
      component: (): Promise<any> => import(/* webpackChunkName: "configuration" */ './views/' + config.codCliente + '/piattaforma-prodotti/database/VitaInvestimento.vue')
        .catch((component : any) => {
          return import(/* webpackChunkName: "configuration" */ './views/piattaforma-prodotti/database/VitaInvestimento.vue');
        }),
      props: true
    },    
    {
      path: '/databaseVitaProtezione',
      name: 'database-vita-protezione',
      component: (): Promise<any> => import(/* webpackChunkName: "configuration" */ './views/' + config.codCliente + '/piattaforma-prodotti/database/VitaProtezione.vue')
        .catch((component : any) => {
          return import(/* webpackChunkName: "configuration" */ './views/piattaforma-prodotti/database/VitaProtezione.vue');
        }),
      props: true
    },
    {
      path: '/databaseDanniAuto',
      name: 'database-danni-auto',
      component: (): Promise<any> => import(/* webpackChunkName: "configuration" */ './views/' + config.codCliente + '/piattaforma-prodotti/database/DanniAuto.vue')
        .catch((component : any) => {
          return import(/* webpackChunkName: "configuration" */ './views/piattaforma-prodotti/database/DanniAuto.vue');
        }),
      props: true
    },    
    {
      path: '/databaseDanniNonAuto',
      name: 'database-danni-non-auto',
      component: (): Promise<any> => import(/* webpackChunkName: "configuration" */ './views/' + config.codCliente + '/piattaforma-prodotti/database/DanniNonAuto.vue')
        .catch((component : any) => {
          return import(/* webpackChunkName: "configuration" */ './views/piattaforma-prodotti/database/DanniNonAuto.vue');
        }),
      props: true
    },
    {
      path: '/databaseCPIPPI',
      name: 'database-cpi-ppi',
      component: (): Promise<any> => import(/* webpackChunkName: "configuration" */ './views/' + config.codCliente + '/piattaforma-prodotti/database/CPI-PPI.vue')
        .catch((component : any) => {
          return import(/* webpackChunkName: "configuration" */ './views/piattaforma-prodotti/database/CPI-PPI.vue');
        }),
      props: true
    },
    {
      path: '/databaseProtezioneInvestimento',
      name: 'database-protezione-investimento',
      component: (): Promise<any> => import(/* webpackChunkName: "configuration" */ './views/' + config.codCliente + '/piattaforma-prodotti/database/ProtezioneInvestimento.vue'),
      props: true
    },
    {
      path: '/databaseProtezionePersona',
      name: 'database-protezione-persona',
      component: (): Promise<any> => import(/* webpackChunkName: "configuration" */ './views/' + config.codCliente + '/piattaforma-prodotti/database/ProtezionePersona.vue'),
      props: true
    },
    {
      path: '/databaseProtezioneImprese',
      name: 'database-protezione-imprese',
      component: (): Promise<any> => import(/* webpackChunkName: "configuration" */ './views/' + config.codCliente + '/piattaforma-prodotti/database/ProtezioneImprese.vue'),
      props: true
    },
    {
      path: '/databaseProtezionePatrimonio',
      name: 'database-protezione-patrimonio',
      component: (): Promise<any> => import(/* webpackChunkName: "configuration" */ './views/' + config.codCliente + '/piattaforma-prodotti/database/ProtezionePatrimonio.vue'),
      props: true
    },
    {
      path: '/databaseProtezioneCredito',
      name: 'database-protezione-credito',
      component: (): Promise<any> => import(/* webpackChunkName: "configuration" */ './views/' + config.codCliente + '/piattaforma-prodotti/database/ProtezioneCredito.vue'),
      props: true
    },
    {
      path: '/dashboardVitaInvestimento',
      name: 'dashboard-vita-investimento',
      component: (): Promise<any> => import(/* webpackChunkName: "configuration" */ './views/piattaforma-prodotti/dashboard/VitaInvestimento.vue'),
      props: true
    },    
    {
      path: '/dashboardVitaProtezione',
      name: 'dashboard-vita-protezione',
      component: (): Promise<any> => import(/* webpackChunkName: "configuration" */ './views/piattaforma-prodotti/dashboard/VitaProtezione.vue'),
      props: true
    },
    {
      path: '/dashboardDanniAuto',
      name: 'dashboard-danni-auto',
      component: (): Promise<any> => import(/* webpackChunkName: "configuration" */ './views/piattaforma-prodotti/dashboard/DanniAuto.vue'),
      props: true
    },    
    {
      path: '/dashboardDanniNonAuto',
      name: 'dashboard-danni-non-auto',
      component: (): Promise<any> => import(/* webpackChunkName: "configuration" */ './views/piattaforma-prodotti/dashboard/DanniNonAuto.vue'),
      props: true
    },
    {
      path: '/dashboardCPIPPI',
      name: 'dashboard-cpi-ppi',
      component: (): Promise<any> => import(/* webpackChunkName: "configuration" */ './views/piattaforma-prodotti/dashboard/CPI-PPI.vue'),
      props: true
    },
    {
      path: '/verifica',
      name: 'verifica',
      component: (): Promise<any> => import(/* webpackChunkName: "configuration" */ './views/VerificaRecuperoPassword.vue'),
      props: true
    },
  ],
});

export default router;
